import type {
  AttachmentTranslationResponse,
  LegislativeItemSearchQuery,
} from '@govinity/validation';
import type {
  LegislativeItemFullSearchBody,
  LegislativeItemFullSearchResponse,
  LegislativeItemHistoryResponse,
  LegislativeItemPublicGetAllResponse,
  LegislativeItemPublicGetResponse,
  LegislativeItemStatisticsResponse,
} from '@govinity/validation/public';

import { ReadOnlyApi } from '../base';

export class LegislativeItemsApi extends ReadOnlyApi<
  LegislativeItemPublicGetAllResponse,
  LegislativeItemPublicGetResponse,
  LegislativeItemSearchQuery
> {
  parentPath: string;
  governmentCode: string;

  constructor(governmentCode: string, parentPath: string) {
    super();

    this.parentPath = parentPath;
    this.governmentCode = governmentCode;
  }

  getPath() {
    return `${this.parentPath}/${this.governmentCode}/legislative-items`;
  }

  async requestAttachmentTranslation(itemId: number, attachmentId: number) {
    const { data } = await this.request<AttachmentTranslationResponse>({
      method: 'POST',
      url: `${this.getPath()}/${itemId}/attachments/${attachmentId}/translation`,
    });

    return data;
  }

  async getStatistics() {
    const { data } = await this.request<LegislativeItemStatisticsResponse>({
      method: 'GET',
      url: `${this.getPath()}/statistics`,
    });

    return data;
  }

  async fullSearch(body: LegislativeItemFullSearchBody) {
    const { data } = await this.request<LegislativeItemFullSearchResponse>({
      method: 'POST',
      url: `${this.getPath()}/full-search`,
      data: body,
    });

    return data;
  }

  async getHistory(id: number) {
    const { data } = await this.request<LegislativeItemHistoryResponse>({
      method: 'GET',
      url: `${this.getPath()}/${id}/history`,
    });

    return data;
  }
}
